import * as React from "react";
import { FormBaseComponent, FormState, SaveDispatchProps } from "@neworbit/simpleui-forms";
import { Form, Button } from "semantic-ui-react";
import { Input } from "@neworbit/simpleui-input";
import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";

import { CANCEL_OHCASE_TASK } from "../../actiontypes";

export interface CloseCaseNoteModel {
    closingNote: string;
}

export interface CloseCaseNoteProps {
    taskId: string;
}

interface State extends FormState<CloseCaseNoteModel> {
    showClosingNotesInput: boolean;
}

export class CloseTaskNoteForm extends
    FormBaseComponent<CloseCaseNoteModel, CloseCaseNoteProps, State> {

    constructor(props: SaveDispatchProps<CloseCaseNoteModel> & CloseCaseNoteProps) {
        super(props);
        this.state = {
            showClosingNotesInput: false,
            values: {
                closingNote: null
            },
            valid: {}
        };
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    public render() {
        if (this.state.showClosingNotesInput === false) {
            return (<Button type="button" content="Close Task" onClick={this.onRequestClose} />);
        }

        return (
            <Form onSubmit={this.handleSubmit} className="close-task-form">
                <Input.Text
                    value={this.state.values.closingNote}
                    label="Reason for closure"
                    required={true}
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("closingNote", value, valid)}
                />
                <IsLoadingButton type="submit" requestNames={`${CANCEL_OHCASE_TASK}_${this.props.taskId}`} content="Close Task" />
            </Form>
        );
    }

    private onRequestClose() {
        this.setState({ showClosingNotesInput: true });
    }
}
